import api from './Client';

export interface VersionInfo {
  minAndroid: number;
  minIos: string;
  storeUrlIos?: string | null;
}

/**
 * Obtiene la versión mínima soportada para las apps móviles desde el backend.
 * El backend debe exponer un endpoint `/api/version` que devuelva un objeto
 * con las claves `minAndroid`, `minIos` y opcionalmente `storeUrlIos`.
 */
export async function getMinVersions(): Promise<VersionInfo> {
  const resp = await api.get('/api/version');
  return resp.data as VersionInfo;
}
